const userGroups = {
  tech: [
    'daniel.pesch@erste-hausverwaltung.de',
    'kalliopi.misiou@erste-hausverwaltung.de',
    'pascal.kumpf@erste-hausverwaltung.de',
    'mohamed.sofi@erste-hausverwaltung.de',
    'ben.craddock@erste-hausverwaltung.de',
    'justus.mentzel@erste-hausverwaltung.de',
    'vincenz.busch@workingsoftware.io',
    'dominik.schmithausen@erste-hausverwaltung.de',
    'bhargavi.chirumamilla@erste-hausverwaltung.de',
    'malek.abdelkader@erste-hausverwaltung.de',
    'florian.pullem@erste-hausverwaltung.de',
    'verena.schwanck@erste-hausverwaltung.de'
  ],
  case_management: [
    'daniel.pesch@erste-hausverwaltung.de',
    'kalliopi.misiou@erste-hausverwaltung.de',
    'pascal.kumpf@erste-hausverwaltung.de',
    'mohamed.sofi@erste-hausverwaltung.de',
    'bhargavi.chirumamilla@erste-hausverwaltung.de',
    'ben.craddock@erste-hausverwaltung.de',
    'justus.mentzel@erste-hausverwaltung.de',
    'vincenz.busch@workingsoftware.io',
    'melissa.hildner@erste-hausverwaltung.de',
    'dominik.schmithausen@erste-hausverwaltung.de',
    'felix.woerner@erste-hausverwaltung.de',
    'jonas.reusswig@erste-hausverwaltung.de',
    'linda.trenz@erste-hausverwaltung.de',
    'doreen.kliebisch@erste-hausverwaltung.de',
    'witta.rumpel@erste-hausverwaltung.de',
    'k.boehme@hv-zieglmeier.de',
    'tim.schneider@erste-hausverwaltung.de',
    'marc.somers@erste-hausverwaltung.de',
    'michelle.gorgas@erste-hausverwaltung.de',
    'till.fleitmann@erste-hausverwaltung.de',
    'martina.ruebsam@erste-hausverwaltung.de',
    'felix.ritschel@erste-hausverwaltung.de',
    'lorena.gentilezza@erste-hausverwaltung.de',
    'alina.cheng@erste-hausverwaltung.de',
    'l.kirchmann@capitol.de',
    'info@se-immo-service.de',
    'ebner@akkurat-abrechnung.de',
    'iris.koenig@sgv-murr.de',
    'michelle.vogt@sgv-murr.de',
    'kirsten.koehler@sgv-murr.de',
    'olga.goedecke@sgv-murr.de',
    'kristina.leibfarth@sgv-murr.de',
    'sandra.schrempf@sgv-murr.de',
    'kerstin.haase@sgv-murr.de',
    'andreas.baeuerle@sgv-murr.de',
  ],
  md: ['patrick.jacob@erste-hausverwaltung.de'],
  beta: [
    'm.czerepak@capitol.de',
    't.wolff@capitol.de',
    'b.esposito@capitol.de',
    's.reisyan@capitol.de',
    'l.kirchmann@capitol.de',
  ],
  performance_reporting_beta: [
    'a.rus@capitol.de',
    'aurelius.rus@erste-hausverwaltung.de',
  ],
  zhv: [
    'c.junker@hv-zieglmeier.de',
    'c.appel@hv-zieglmeier.de',
    'e.stey@hv-zieglmeier.de',
    'g.kohnle@hv-zieglmeier.de',
    'i.hautz@hv-zieglmeier.de',
    'j.simic@hv-zieglmeier.de',
    'k.boehme@hv-zieglmeier.de',
    'lars.zieglmeier@hv-zieglmeier.de',
    'm.martin@hv-zieglmeier.de',
    'm.gmeiner@hv-zieglmeier.de',
    's.hadria@hv-zieglmeier.de',
    't.gruener@hv-zieglmeier.de',
    'v.kucheriava@hv-zieglmeier.de',
  ],
  capitol: [
    'aurelius.rus@erste-hausverwaltung.de',
    'r.wolff@capitol.de',
    'l.kirchmann@capitol.de',
    'm.czerepak@capitol.de',
    's.reisyan@capitol.de',
    's.ahrens@capitol.de',
    'b.esposito@capitol.de',
    'h.hallaschek@capitol.de',
    's.chennour@capitol.de',
    'b.meissner@capitol.de',
    'k.beslagic@capitol.de',
    'm.krebs@capitol.de',
  ],
  ehvd: [
    'alexander.tech@erste-hausverwaltung.de',
    'till.fleitmann@erste-hausverwaltung.de',
    'marc.somers@erste-hausverwaltung.de',
    'robin.werkmeister@erste-hausverwaltung.de',
    'michelle.gorgas@erste-hausverwaltung.de',
  ],
  sgv: [
    'iris.koenig@sgv-murr.de',
    'michelle.vogt@sgv-murr.de',
    'kirsten.koehler@sgv-murr.de',
    'olga.goedecke@sgv-murr.de',
    'kristina.leibfarth@sgv-murr.de',
    'sandra.schrempf@sgv-murr.de',
    'kerstin.haase@sgv-murr.de',
    'andreas.baeuerle@sgv-murr.de',
  ],
  reporting_beta: [
    'martina.ruebsam@erste-hausverwaltung.de',
    'melissa.hildner@erste-hausverwaltung.de',
    'tim.schneider@erste-hausverwaltung.de'
  ],
  special_services_beta: [
    'marc.somers@erste-hausverwaltung.de',
    'k.boehme@hv-zieglmeier.de',
    'till.fleitmann@erste-hausverwaltung.de',
    'melissa.hildner@erste-hausverwaltung.de',
    'aurelius.rus@erste-hausverwaltung.de',
    'tim.schneider@erste-hausverwaltung.de',
    'iris.koenig@sgv-murr.de',
    'michelle.vogt@sgv-murr.de',
    'kirsten.koehler@sgv-murr.de',
    'olga.goedecke@sgv-murr.de',
    'kristina.leibfarth@sgv-murr.de',
    'sandra.schrempf@sgv-murr.de',
    'kerstin.haase@sgv-murr.de',
    'andreas.baeuerle@sgv-murr.de',
  ],
  tasks_beta: [
    'daniel.pesch@erste-hausverwaltung.de',
    'pascal.kumpf@erste-hausverwaltung.de',
    'kalliopi.misiou@erste-hausverwaltung.de',
    'melissa.hildner@erste-hausverwaltung.de',
    'tim.schneider@erste-hausverwaltung.de',
    'iris.koenig@sgv-murr.de',
    'michelle.vogt@sgv-murr.de',
    'kirsten.koehler@sgv-murr.de',
    'olga.goedecke@sgv-murr.de',
    'kristina.leibfarth@sgv-murr.de',
    'sandra.schrempf@sgv-murr.de',
    'kerstin.haase@sgv-murr.de',
    'andreas.baeuerle@sgv-murr.de',
  ],
  accounting: [
    'kalliopi.misiou@erste-hausverwaltung.de',
    'info@se-immo-service.de',
    'linda.trenz@erste-hausverwaltung.de',
    'doreen.kliebisch@erste-hausverwaltung.de',
    'witta.rumpel@erste-hausverwaltung.de'
  ]

}

const getUserRoles = (userEmail) => {
  const roles = []
  for (const [role, emails] of Object.entries(userGroups)) {
    if (emails.includes(userEmail)) {
      roles.push(role)
    }
  }
  return roles.length > 0 ? roles : ['user']
}

const isInRole = (role) => {
  const email = JSON.parse(localStorage.getItem('auth'))?.email || null
  if (!email) return false
  const roles = getUserRoles(email)
  return roles.includes(role)
}

// Make isInRole globally available
window.isInRole = isInRole
